export default {
  data() {
    return {
      mustBeTitle: [
        v => !!v || "title is required",
        v => (v && v.length <= 50) || "name must be less than 50 characters"
      ],
      mustBeIDShort: [
        v => !!v || "id is required",
        v => (v && v.length <= 10) || "name must be less than 10 characters"
      ],
      mustBeLessThanSmall: [
        v => !!v || "required",
        v => (v && v.length <= 50) || "name must be less than 50 characters"
      ],
      mustBeLessThanAnyNotRequired: [
        // eslint-disable-next-line
        v => !!v || "name is required",
        // v => (v.length <= 50) || "name must be less than 50 characters"
      ],
      // eslint-disable-next-line
      mustBeLessThanLarge: [
        v => !!v || "description is required",
        // eslint-disable-next-lineF
        v => (v && v.length <= 1000) || "name must be less than 1000 characters"
      ],
      mustBeLessThanLargeNotRequired: [
        // eslint-disable-next-line
        v => (v.length <= 1000) || "name must be less than 1000 characters"
      ],
      mustBeLessThanSmallNotRequired: [
        // eslint-disable-next-line
        v => (v.length <= 50) || "name must be less than 50 characters"
      ],
      // eslint-disable-next-line
      mustBeNumber: [
        v => !!v || "required",
        // eslint-disable-next-line
        v => (v > 0) || "must be > 0"
      ],
      // eslint-disable-next-line
      mustBeNumberNegOrPos: [
        v => !!v || "required",
        // eslint-disable-next-line
        v => (v > -9990000999) || "must be a number",
      ],
      // eslint-disable-next-line
      mustBeMobilePhoneNumber: [
        v => !!v || "required",
        // eslint-disable-next-line
        v => (v.length == 9) || "must be 9 digits mobile"
      ],
      // eslint-disable-next-line
      mustBeMobilePhoneNumberAus: [
        v => !!v || "required",
        // eslint-disable-next-line
        v => (v.length == 10) || "must be Aus mobile"
      ],
      mustBeZeroOrMore: [
        v => !!v || "required",
        // eslint-disable-next-line
        v => (v >= 0) || "must be > 0"
      ],
      IsRequired: [v => !!v || "item is required"],
      ruleMustBeSelected: [
        // eslint-disable-next-line
        v => !!v || "must be selected"
      ],
      ruleMustBeFilledANDLessThan25: [
        // eslint-disable-next-line
        v => (!!v && v.length <= 25) ||
          "must be filled and less than 25 characters"
      ],
      ruleMustBeFilledANDLessThan50: [
        // eslint-disable-next-line
        v => (!!v && v.length <= 50) ||
          "must be filled and less than 50 characters"
      ],
      ruleMustBeFilledANDLessThan100: [
        // eslint-disable-next-line
        v => (!!v && v.length <= 100) ||
          "must be filled and less than 100 characters"
      ],
      ruleMustBeFilledANDLessThan500: [
        // eslint-disable-next-line
        v => (!!v && v.length <= 500) ||
          "must be filled and less than 500 characters"
      ],
      ruleMustBeFilledANDLessThan1000: [
        // eslint-disable-next-line
        v => (!!v && v.length <= 1000) ||
          "must be filled and less than 1000 characters"
      ],
      ruleMustBeFilledANDLessThan2500: [
        // eslint-disable-next-line
        v => (!!v && v.length <= 2500) ||
          "must be filled and less than 2500 characters"
      ],
      ruleMustBeFilledANDNumberMoreThanZero: [
        // eslint-disable-next-line
        v => (!!v && v > 0) ||
          "must be greater than zero"
      ],
      // eslint-disable-next-line
      ruleNumberMoreThanZero: [
        // eslint-disable-next-line
        v => (v > 0) ||
          "must be > 0"
      ],
      // eslint-disable-next-line
      ruleNumberPositive: [
        // eslint-disable-next-line
        v => (v > -0.000000001) ||
          "must be positive"
      ],
      // eslint-disable-next-line
      ruleNumberMoreThanZeroAndLessThanOne: [
        // eslint-disable-next-line
        v => (v > 0 && v < 1.01) ||
          "must be > 0 and less than 1.01"
      ],
      // eslint-disable-next-line
      ruleMustBeNotUndefinedANDLessThan25: [
        // eslint-disable-next-line
        v => (v !== undefined && v.length <= 25) ||
          "must be less than 25 characters"
      ],
      ruleMustBeNotUndefinedANDLessThan100: [
        // eslint-disable-next-line
        v => (v !== undefined && v.length <= 100) ||
          "must be less than 100 characters"
      ],
      ruleMustBeNotUndefinedANDLessThan50: [
        // eslint-disable-next-line
        v => (v !== undefined && v.length <= 50) ||
          "must be less than 50 characters"
      ],
      ruleMustBeNotUndefinedANDLessThan2000: [
        // eslint-disable-next-line
        v => (v !== undefined && v.length <= 2000) ||
          "must be less than 2000 characters"
      ],
      ruleMustBeNotUndefinedANDLessThan500: [
        // eslint-disable-next-line
        v => (v !== undefined && v.length <= 500) ||
          "must be less than 500 characters"
      ],
      ruleMustLessThan25: [
        // eslint-disable-next-line
        v => (v.length <= 25) ||
          "must be filled and less than 25 characters"
      ],
      ruleMustLessThan50: [
        // eslint-disable-next-line
        v => (v.length <= 50) ||
          "must be filled and less than 50 characters"
      ],
      ruleMustBeLessThan500: [
        // eslint-disable-next-line
        v => (v.length <= 500) ||
          "must be filled and less than 1000 characters"
      ],
      ruleMustLessThan1000: [
        // eslint-disable-next-line
        v => (v.length <= 1000) ||
          "must be filled and less than 1000 characters"
      ],
      ruleMustBeNotUndefinedANDLessThan1000: [
        // eslint-disable-next-line
        v => (v !== undefined && v.length <= 1000) ||
          "must be less than 1000 characters"
      ]
    };
  }
};
